<template>
  <router-view class="text-gray-700 min-h-screen font-sans" />
</template>

<style>

</style>
